export default (total) => ({
    active: 0,
    duration: 3000,
    total: total,
    imgHeight: 500,
    
    init() {
        console.log('init');
        // this.imgHeight = Math.floor($el.querySelectorAll('.slider_slide')[0].getBoundingClientRect().height) + 'px';
    },
  
    resize(e) {
        console.log('resize');
        console.log(e.querySelectorAll('.slider_slide')[0].querySelector('img').getBoundingClientRect());
        this.imgHeight = Math.floor(e.querySelectorAll('.slider_slide')[0].getBoundingClientRect().height);
    },
    // start() {
    //     setInterval(() => {
    //         this.next();
    //     }, this.duration);
    // },
  
    next(e) {
        console.log('next');  
        // console.log(e.target);
        if(this.active == this.total) {
            this.active = 0;
        } else {
            this.active = this.active + 1;
        }
        this.imgHeight = Math.floor(e.target.closest('.slider_container').querySelectorAll('.slider_slide')[this.active].getBoundingClientRect().height);
    },

    prev(e) {
        console.log('prev');
        // console.log(e.target);
        if(this.active == 0) {
            this.active = this.total;
        } else {
            this.active = this.active - 1;
        }
        this.imgHeight = Math.floor(e.target.closest('.slider_container').querySelectorAll('.slider_slide')[this.active].getBoundingClientRect().height);
    }

});